<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
  >
    <stock-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-create>
</template>

<script>

import StockProvider from "../../../../providers/StockProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import StockForm from "../StockForm";


export default {
  name: "StockCreate",

  components: {StockForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'delivery.stock.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        branch: null,
        items: []
      }
    }
  },

  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        StockProvider.createStock(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createStock)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }

  },
}
</script>

<style scoped>

</style>

